import { useEffect, useState } from "react";
import { StrategyMapActionHeader } from "./components/StrategyMapActionHeader/StrategyMapActionHeader";
import { StrategyMapViewHeader } from "./components/StrategyMapViewHeader/StrategyMapViewHeader";
import { StrategyMapViewSubHeader } from "./components/StrategyMapViewSubHeader/StrategyMapViewSubHeader";
import * as def from "./StrategyMapView.def";
import { useSingleSmapFetch } from "../../hooks/Smap/useSingleSmap";
import { StrategyMapTimelineView } from "./components/StrategyMapTimelineView/StrategyMapTimelineView";
import { useParams, useSearchParams } from "react-router-dom";
import { StrategyMapTableView } from "./components/StrategyMapTableView/StrategyMapTableView";
import { useSelector } from "react-redux";
import { StrategyMapReduxViewState } from "../../redux/slices/strategyMapView";
import { useJwt } from "../../helpers/common";
import store from "../../redux/store";
import { setViewType } from "../../redux/slices/timeline";


export function StrategyMapView() {
    const { strategymap_id } = useParams()
    const [searchParams] = useSearchParams();
    const currentScrollId = searchParams.get("active"); 
    const currentTab = searchParams.get("tab"); 

    const [strategyMapViewState, setStrategyMapViewState] =
      useState<def.StrategyMapViewStateType>(() => {
        const saved = localStorage.getItem("strategyMapView_state");
        const initialValue = saved ? JSON.parse(saved) : null;
        

        const saved_timeline_state = localStorage.getItem("timeline_state");
        const saved_timeline_auto_state =
          localStorage.getItem("timeline_auto_state") ?? "true";
        const saved_timeline_auto =
          saved_timeline_auto_state === "true" ? true : false;
        
        const saved_view_type = store.getState().timeline.viewType ?? "timeline";

        return {
          viewMode: saved_view_type || "timeline",
          timeLineViewAutoMode: saved_timeline_auto ?? false,
          timelineViewType: saved_timeline_state || "yearly",
          gantViewMode: initialValue?.gantViewMode || "normal",
          stats: {},
          simulation: store.getState().timeline.simulation ?? false,
          strageyMapData: null,
          sidebarCollapsed: false,
          idForScroll: "",
          refreshKey: 0,
          hardRefreshKey: 0,
          loadingSingleStrategyMap: true,
          orgDetails: {
            orgId: "",
            orgRole: "",
          },
          showCost: initialValue?.showCost ?? false,
        };
      });

        
    const { data: strategyMapData, loadSingleStrategyMap, loading: loadingSingleStrategyMap } = useSingleSmapFetch(strategymap_id ??"", {
      onLoad:()=>{
        
        setTimeout(() => {
          
          setStrategyMapViewState((pv) => {
            return ({
              ...pv,
              idForScroll: currentScrollId ?? "",
            });
          });
        }, 40);
      },
      beforeLoad:()=>{
        setStrategyMapViewState((pv) => ({
          ...pv,
          idForScroll: "",
        }));
      }
    });
   
  
    useEffect(() => {
      localStorage.setItem(
        "strategyMapView_state",
        JSON.stringify({
          timeLineViewAutoMode: strategyMapViewState.timeLineViewAutoMode,
          viewMode: strategyMapViewState.viewMode,
          timelineViewType: strategyMapViewState.timelineViewType,
          gantViewMode: strategyMapViewState.gantViewMode,
          showCost: strategyMapViewState.showCost,
        })
      );

      localStorage.setItem("timeline_state", strategyMapViewState.timelineViewType);
      localStorage.setItem(
        "timeline_auto_state",
        strategyMapViewState.timeLineViewAutoMode ? "true" : "false",
      );
      

      store.dispatch(setViewType(strategyMapViewState.viewMode));
      

    }, [
      strategyMapViewState.viewMode,
      strategyMapViewState.timelineViewType,
      strategyMapViewState.gantViewMode,
      strategyMapViewState.showCost,
    ]);

      
      
      const jwtData: any = useJwt();

      const currentOrgId = jwtData.org_id;
      const { orgRole } = jwtData;

      const global_data = useSelector(
        (t: any) => t.strategyMapView,
      ) as StrategyMapReduxViewState;

      const { show_cost: showCost } = useSelector(
        (state: any) => state.organization.orgDetails,
      );
      


    useEffect(()=>{
        setStrategyMapViewState((pv) => ({
            ...pv,
            orgDetails: {
              orgId: currentOrgId,
              orgRole,
            },
          }));
    }, [currentOrgId, orgRole])

    useEffect(()=>{
        setStrategyMapViewState((pv) => ({
            ...pv,
            showCost,
          }));
    }, [showCost])

    useEffect(()=>{
        setStrategyMapViewState((pv) => {

            const cachedStrategyMap = global_data?.strategyMapData[strategymap_id ?? ""];
            return ({
                ...pv,
                strageyMapData: cachedStrategyMap?.data,
                idForScroll: cachedStrategyMap?.scrollToId,
                refreshKey: global_data.refreshKey,
            });
        });
    }, [global_data])
    
 


    useEffect(() => {
        if (strategyMapData) {
            setStrategyMapViewState((pv) => ({
                ...pv,
                strageyMapData: strategyMapData,
                stats: strategyMapData.stats || pv.stats
            }));
        }
    }, [strategyMapData]);

    useEffect(() => {
        if(strategyMapViewState.refreshKey > 0){
            loadSingleStrategyMap(strategymap_id ??"");
        }
    }, [strategyMapViewState.refreshKey]);

    useEffect(() => {
      if (strategyMapViewState.hardRefreshKey > 0) {
        loadSingleStrategyMap(strategymap_id ?? "",true);
      }
    }, [strategyMapViewState.hardRefreshKey]);

    useEffect(() => {
       setStrategyMapViewState((pv) => ({
         ...pv,
         loadingSingleStrategyMap,
       }));
    }, [loadingSingleStrategyMap]);
    
    useEffect(() => {
      if (currentScrollId) {
        setStrategyMapViewState((pv) => ({
          ...pv,
          idForScroll: currentScrollId,
        }));
      }
    }, [currentScrollId]);


    const state = {
        get: strategyMapViewState,
        set: setStrategyMapViewState,
    }

    return (
      <div
        className="row bg-tertiary-light dark:bg-tertiary-dark w-full relative flex flex-col h-[100vh] flex-1"
      >
        <StrategyMapViewHeader state={state} />
        <StrategyMapViewSubHeader state={state} />
        <StrategyMapActionHeader state={state} />
        {state.get.viewMode == "timeline" && (
          <StrategyMapTimelineView state={state} />
        )}
        {state.get.viewMode == "list" && (
          <StrategyMapTableView state={state} />
        )}
      </div>
    );
}